<template>
  <div class="device-disk">
    <img class="img" :src="imgUrl"/>
    <p class="deviceno" v-if="deviceNo">NO.{{deviceNo}}</p>
    <p class="info" v-else>尚未设置税盘信息</p>
    <p class="online" v-if="deviceOnlineStatus === true && deviceNo">在线</p>
    <p class="offline" v-if="deviceOnlineStatus === false && deviceNo">离线</p>
  </div>
</template>

<script>
import baiwangImg from '@/assets/img/baiwang.png'
import hangxinImg from '@/assets/img/hangxin.png'
import ukeyImg from '@/assets/img/ukey.png'
import serverImg from '@/assets/img/server.png'
import diskEmpty from '@/assets/img/disk-empty.png'
export default {
  components: {},
  props: {
    toolsType: {
      type: [String, Number],
      default: ''
    },
    deviceNo: {
      type: String,
      default: ''
    },
    deviceOnlineStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    imgUrl () {
      if (this.toolsType === 0) {
        return hangxinImg
      } else if (this.toolsType === 1) {
        return baiwangImg
      } else if (this.toolsType === 2) {
        return ukeyImg
      } else if (this.toolsType === 3) {
        return serverImg
      } else {
        return diskEmpty
      }
    }
  },
  watch: {},
  created () {},
  mounted () {},
  activated () {},
  updated () {},
  methods: {}
}
</script>
<style scoped lang='less' src="./style.less"></style>
